import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { endAdminSession } from "@/features/auth/session/endAdminSession";

/** Ends the admin session and returns the user to the login screen. */
export function useAdminLogout() {
  const navigate = useNavigate();

  return useCallback(() => {
    endAdminSession();
    navigate("/login", { replace: true });
  }, [navigate]);
}
